import React from 'react';
/* eslint-disable react/react-in-jsx-scope */
import moment from 'moment';
import 'moment-timezone';
import {
  isEmpty as _isEmpty,
  filter as _filter,
  map as _map,
  slice as _slice,
  cloneDeep as _cloneDeep,
  forEach as _forEach,
  find as _find,
  isNull as _isNull,
  maxBy as _maxBy,
  isArray as _isArray,
  isString as _isString,
  isUndefined as _isUndefined,
  isNaN as _isNaN,
  uniq as _uniq,
  flatten as _flatten,
  get as _get,
  some as _some,
  startsWith as _startsWith
} from 'lodash-es';
import { message } from 'antd';
import { t } from 'i18next';
import { apiServices } from 'redux/utils/api_services';
import {
  updateDataFromApiAction,
  postDataFromApiAction
} from 'components/Atoms/GraasApiUtility/GraasApiUtility.action';
import { initiateChannel } from 'redux/Account/Account.action';
import Cookies from 'js-cookie';
import queryString from 'query-string';
import TooltipWrapper from 'components/Atoms/TooltipWrapper/TooltipWrapper';
import { channelToLogo } from 'components/Atoms/GraasChannelWithLogo/utility';
import { useDispatch } from 'react-redux';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

// ---- ICONS - Small ----
import mailchimp_small from '../assets/images/integrations/avator_mailchimp_logo.png';
import sendgrid_small from '../assets/images/integrations/graas_logo_small.svg';
import GoogleAds_small from '../assets/images/integrations/google-ads-fevicon.svg';
import GoogleAnalytics_small from '../assets/images/integrations/google-analytics-fevicon.svg';
import Shoptimize_small from '../assets/images/integrations/shoptimize-fevicon.svg';
import FacebookAds_small from '../assets/images/integrations/facebookAds-fevicon.svg';
import GoogleSearchConsole_small from '../assets/images/integrations/google-console-fevicon.svg';
import Shopify_small from '../assets/images/integrations/shopify-fevicon.svg';
import Shopee_small from '../assets/images/integrations/shopee-favicon.svg';
import Lazada_small from '../assets/images/integrations/lazada-fevicon.svg';
import GraasIconSmall from 'assets/images/graas_logo_small.svg';
import Graas from 'assets/images/graas_white.svg';
import countryDetails from '../assets/country/CountryDetails.json';
import amazon_small from '../assets/images/integrations/avator_Amazon_logo.png';
import flipkart_small from '../assets/images/integrations/avator_flipkart_logo.png';
import zalora_small from '../assets/images/integrations/zalora_favicon.png';
import blinkit_small from '../assets/images/integrations/blinkit_favicon.png';
import zepto_small from '../assets/images/integrations/zepto_favicon.png';
import tokopedia_small from '../assets/images/integrations/avator_tokopedia_logo.png';
import jd_small from '../assets/images/integrations/avator_jd_logo.png';
import tiki_small from '../assets/images/integrations/avator_tiki_logo.png';
import blibli_small from '../assets/images/integrations/avator_blibli_logo.png';
import tiktok_small from '../assets/images/integrations/avator_tiktok_logo.png';
import eleven_street_small from '../assets/images/integrations/avator_elevenStreet_logo.png';
import etsy_small from '../assets/images/integrations/avator_etsy_logo.png';
import qoo10_small from '../assets/images/integrations/avator_qoo10_logo.png';
import ebay_small from '../assets/images/integrations/avator_ebay_logo.png';
import ajio_small from '../assets/images/integrations/ajio.png';
import bukalapak_small from '../assets/images/integrations/avator_bukalapak_logo.png';
import MagentoLogo from 'assets/images/integrations/avator_magento_logo.png';
import wooCommerceLogo from 'assets/images/integrations/avator_Layer-1.png';
import prestaShopLogo from 'assets/images/integrations/avator_prestashop_logo.png';
import shiprocketLogo from 'assets/images/integrations/avator_shiprocket_logo.png';
import semrushLogo from 'assets/images/integrations/avator_semrush_logo.png';
import delhiveryLogo from 'assets/images/integrations/avator_delhivery_logo.png';
import lighthouseLogo from 'assets/images/integrations/avator_lighthouse_logo.png';
import offlineLogo from 'assets/images/integrations/avator_offline_logo.png';
import myntraLogo from 'assets/images/integrations/Myntra.jpg';
import noLogo from 'assets/images/integrations/no-logo.png';
import { getChannelList } from 'redux/Chart/chart.action';
import tokopedia from 'assets/images/integrations/avator_tokopedia_logo.png';
import salesforce from 'assets/images/integrations/large/salesforce.png';
import nykaaLogo from 'assets/images/integrations/nykaa.png';
import tiktokAds_small from '../assets/images/integrations/avator_tiktok_ads_logo.png';
import unicommerceLogo from 'assets/images/integrations/unicommerceLogo.png';
import easyEcomLogo from 'assets/images/integrations/easyEcomLogo.png';
import { dateRangeMapping } from 'components/Recommendation/initialStates';
import myntraSjitLogo from 'assets/images/integrations/myntraSjit.jpg';
import meeshoLogo from 'assets/images/integrations/meeshoLogo.png';
import tataCliqLogo from 'assets/images/integrations/tataCliqLogo.png';

import snowflake from 'assets/images/integrations/snowflake.png';
import mysql from 'assets/images/integrations/mysql.png';
import gsheet from 'assets/images/integrations/gsheet.png';
import excel from 'assets/images/integrations/excel.png';
import azure from 'assets/images/integrations/azure.png';
import aws from 'assets/images/integrations/aws.png';
import { getIsDemoHost } from './demo_utilities';
// ---- ICONS MAPPING ----

const urlPermissionEnabledAccountForSupportUser =
  process.env.REACT_APP_URL_RESTRICTION_ENABLED_ACCOUNTS_FOR_SUPPORT_USER.split(',');

export const idToIconMap = {
  fbads: {
    small: FacebookAds_small,
    title: 'Facebook Ads'
  },
  ga: { small: GoogleAnalytics_small, title: 'Google Analytics' },
  gads: { small: GoogleAds_small, title: 'Google Ads' },
  gsc: { small: GoogleSearchConsole_small, title: 'Google Search Console' },
  mg: { small: Shoptimize_small, title: 'Web Hosting Platform' },
  shp: { small: Shoptimize_small, title: 'Shoptimize Tracker' },
  shf: { small: Shopify_small, title: 'Shopify' },
  shpe: { small: Shopee_small, title: 'Shopee' },
  lz: { small: Lazada_small, title: 'Lazada' },
  d2c: { small: GraasIconSmall, large: Graas, title: 'D2C' },
  mkp: { small: GraasIconSmall, large: Graas, title: 'Marketplace' },
  mailchimp: { small: mailchimp_small, large: Graas, title: 'Mailchimp' },
  sendgrid: { small: sendgrid_small, large: Graas, title: 'SendGrid' },
  amazon: { small: amazon_small, title: 'Amazon' },
  flipkart: { small: flipkart_small, title: 'Flipkart' },
  zalora: { small: zalora_small, title: 'Zalora' },
  tokopedia: { small: tokopedia_small, title: 'Tokopedia' },
  jd: { small: jd_small, title: 'JD' },
  tiki: { small: tiki_small, title: 'Tiki' },
  blibli: { small: blibli_small, title: 'Blibli' },
  tiktok: { small: tiktok_small, title: 'Tiktok' },
  eleven_street: { small: eleven_street_small, title: 'Eleven Street' },
  etsy: { small: etsy_small, title: 'Etsy' },
  qoo10: { small: qoo10_small, title: 'Qoo10' },
  ebay: { small: ebay_small, title: 'Ebay' },
  bukalapak: { small: bukalapak_small, title: 'Bukalapak' },
  myntra: { small: myntraLogo, title: 'Myntra' },
  noLogo: { small: noLogo, title: 'noImage' },
  wooCommerce: { small: wooCommerceLogo, title: 'wooCommerce' },
  magento: { small: MagentoLogo, title: 'magento' },
  tokopedia: { small: tokopedia, title: 'tokopedia' },
  salesforce: { small: salesforce, title: 'salesforce' },
  nykaa: { small: nykaaLogo, title: 'nykaa' },
  offline: { small: offlineLogo, title: 'Offline' },
  lighthouse: { small: lighthouseLogo, title: 'Lighthouse' },
  tiktokAds: { small: tiktok_small, title: 'TiktokAds' },
  ajio: { small: ajio_small, title: 'ajio' },
  easyEcom: { small: easyEcomLogo, title: 'Easy Ecom' },
  unicommerce: { small: unicommerceLogo, title: 'Unicommerce' },
  myntraSjit: { small: myntraSjitLogo, title: 'MyntraSjit' },

  aws: { small: aws, title: 'AWS' },
  gsheet: { small: gsheet, title: 'Google Sheets' },
  excel: { small: excel, title: 'Excel' },
  azure: { small: azure, title: 'Azure' },
  mysql: { small: mysql, title: 'MySQL' },
  snowflake: { small: snowflake, title: 'Snowflake' }
};

// ---- SIDEBAR KEYS ----
export const SIDEBAR_KEYS = ['notification', 'solutions'];

// ---- Routes mapping ----
export const routesMapping = {
  dashboard: '/analyze/workspace',
  signOut: '/logout',
  home: '/home',
  attribution: '/analyze/attribution-model',
  segment: '/execute/segments',
  productMaster: '/execute/#product-master',
  businessProfile: '/profile/business-profile',
  segments: '/executor/segments',
  index: '/execute/#index',
  competitiveDashboard: '/analyze/competitive-dashboard',
  accessDenied: '/analyze/access-denied',
  advertisement: '/executor/advertisements',
  customDashboard: '/analyze/custom-dashboard',
  chartBuilder: '/analyze/chart-builder',
  workspace: '/analyze/workspace',
  connect: '/connect',
  batchListing: '/execute/#batch-listing',
  custom_category: '/connect/mapping?type=category',
  promotion: '/executor/promotion-beta'
};

export const truncateString = (stringText, numberTillTruncat) => {
  return stringText?.length > numberTillTruncat ? stringText.substring(0, numberTillTruncat - 1) + '...' : stringText;
};

// ----------- DATE - MOMENT Related Functions ----------------
export const stringToMoment = rangeStrings =>
  rangeStrings ? [moment(rangeStrings[0]).format('YYYY-MM-DD'), moment(rangeStrings[1]).format('YYYY-MM-DD')] : null;

export const stringToMomentWithoutFormat = rangeStrings =>
  rangeStrings ? [moment(rangeStrings[0]), moment(rangeStrings[1])] : null;

export const stringToMomentWithCustomFormat = (rangeStrings, format) =>
  rangeStrings ? [moment(rangeStrings[0]).format(format), moment(rangeStrings[1]).format(format)] : null;

// --- Copy to clipBoard
export const copyURLToClipboard = props => {
  const urlToCopy = !_isEmpty(props) ? props : window.location.href;
  navigator.clipboard.writeText(urlToCopy);
  message.success(t('GRAAS_LINK_COPIED_TO_CLIPBOARD_GRAAS'));
};

export const unixToDateFormat = (unix_time_stamp, format) => {
  return moment(unix_time_stamp).format(format);
};

export const unixToDateFormatWithTimeZone = (unix_time_stamp, format, timezone) => {
  if (_isEmpty(timezone)) {
    return moment(unix_time_stamp).format(format);
  }
  return moment(unix_time_stamp).tz(timezone).format(format);
};

export const stringDateToUnixTimestamp = (string_date, format) => {
  return moment(string_date, format).valueOf();
};

export const removeCurrencySymbolFromAmount = value => {
  return parseFloat(value?.replace(/[^0-9\.-]+/g, ''));
};

export const getCurrentDateInUnix = start_of_day => {
  /*
Accepted parameter start_of_day (boolean)
Example:
  start_of_day == true
  then return unix timestamp equals to start of the day. (date with 12AM)
  Otherwise return current unix timestamp.
*/
  return start_of_day !== undefined && start_of_day ? moment().startOf('day').unix() * 1000 : moment().unix();
};

export const currecnySymbolMetrics = ['revenue', 'aov', 'ad spend', 'roas', 'adspend'];

export const chormeExtensionHanldedChannel = ['lazada', 'shopee', 'amazon', 'tokopedia', 'flipkart'];

//need to remove in future
export const skippedChannels = [
  'sellInAll',
  'payPal',
  'shopclues',
  'kartrocket',
  'snapdeal',
  'wish',
  'faceBook',
  '99SME',
  'pinterest',
  'lelong',
  'priceminister',
  'daraz',
  'googleAnalytics',
  'shiprocket',
  'googleSearchConsole',
  'lighthouse',
  'semrush',
  'mailchimp',
  'easyEcom'
];

export const inCompleteActionRequiredChannels = ['tokopedia', 'facebookAds'];

export const quadrantViewEnabledChannels = ['shopee', 'lazada', 'shopify', 'amazon', 'tokopedia', 'flipkart'];

export const beforeUpload = file => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error(t('GRAAS_UPLOAD_VALID_FILE_FORMAT_GRAAS'));
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error(t('GRAAS_UPLOAD_VALID_SIZE_FILE_GRAAS'));
  }
  return isJpgOrPng && isLt2M;
};

// --- number formatter
export const numberFormatter = num => {
  const formattedNumber =
    Math.abs(num) > 999 ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'k' : Math.sign(num) * Math.abs(num);
  return formattedNumber || num;
};

export const getCurrencyCodeSymbol = currencyCode => {
  for (let index in countryDetails) {
    if (countryDetails[index]?.currencyCode === currencyCode) {
      return `${countryDetails[index].currencyCode} (${countryDetails[index].currencySymbol})`;
    }
  }
};

export const channelNameToIconMap = {
  SHOPIFY: Shopify_small,
  MAGENTO: MagentoLogo,
  WOOCOMMERCE: wooCommerceLogo,
  LAZADA: Lazada_small,
  SHOPEE: Shopee_small,
  SHOPEEGLOBAL: Shopee_small,
  TOKOPEDIA: tokopedia_small,
  FACEBOOKADS: FacebookAds_small,
  GOOGLEADS: GoogleAds_small,
  JD: jd_small,
  TIKI: tiki_small,
  FLIPKART: flipkart_small,
  FLIPKARTADS: flipkart_small,
  AMAZON: amazon_small,
  AMAZONADS: amazon_small,
  ZALORA: zalora_small,
  TIKTOK: tiktok_small,
  ELEVENSTREET: eleven_street_small,
  BLIBLI: blibli_small,
  GOOGLEANALYTICS: GoogleAnalytics_small,
  PRESTASHOP: prestaShopLogo,
  ETSY: etsy_small,
  BUKALAPAK: bukalapak_small,
  EBAY: ebay_small,
  QOO10: qoo10_small,
  SHIPROCKET: shiprocketLogo,
  DELHIVERY: delhiveryLogo,
  GOOGLESEARCHCONSOLE: GoogleSearchConsole_small,
  LIGHTHOUSE: lighthouseLogo,
  MAILCHIMP: mailchimp_small,
  SEMRUSH: semrushLogo,
  OFFLINE: offlineLogo,
  MYNTRA: myntraLogo,
  NYKAA: nykaaLogo,
  AJIO: ajio_small,
  TIKTOKADS: tiktokAds_small,
  SALESFORCE: salesforce,
  EASYECOM: easyEcomLogo,
  UNICOMMERCE: unicommerceLogo,
  MEESHO: meeshoLogo,
  TATACLIQ: tataCliqLogo,
  BLINKIT: blinkit_small,
  ZEPTO: zepto_small,
  BLINKITADS: blinkit_small,
  ZEPTOADS: zepto_small
};

export const getCompareRangeFromDate = rangeStrings => {
  let diff = moment(rangeStrings[1]).diff(moment(rangeStrings[0]));
  return [
    moment(rangeStrings[0]).subtract(diff).subtract(1, 'd'),
    moment(rangeStrings[1]).subtract(diff).subtract(1, 'd')
  ];
};

export function checkURLParams(param) {
  var vars = {};
  window.location.href.replace(
    /[?&]+([^=&]+)=?([^&]*)?/gi, // regexp
    function (m, key, value) {
      // callback
      vars[key] = value !== undefined ? value : '';
    }
  );
  if (param) {
    return vars[param] ? vars[param] : null;
  }
  return vars;
}

export const getTimeZoneByCountryCode = countryCode => {
  return (
    _filter(countryDetails, function (countryDetail) {
      return countryDetail?.countryCode === countryCode;
    })?.[0]?.timeZone || 'UTC'
  );
};

export const getChannelsList = async (enabledChannels, selectedNickNameIds) => {
  const response = await getChannelList();
  const availableChannelObj = [];
  _map(response?.nicknames, nickNameObj => {
    let obj = _cloneDeep(nickNameObj);
    let channel = obj?.id?.split('-')[0];
    obj.value = channel + '-' + obj?.value;
    let status = obj?.status || 'A';
    if (status !== 'X' && enabledChannels.includes(channel)) {
      if (!skippedChannels.includes(channel)) {
        availableChannelObj?.push(obj);
        if (!selectedNickNameIds.includes(obj?.id)) {
          selectedNickNameIds?.push(obj?.id);
        }
      }
    }
  });
  return availableChannelObj;
};

export const getNickNameIdsList = nickNameObjList => {
  const nickNameIdsList = [];
  _map(nickNameObjList, nickNameObj => {
    let obj = _cloneDeep(nickNameObj);
    let channel = obj?.id?.split('-')[0];
    obj.value = channel + '-' + obj?.value;
    let status = obj?.status || 'A';
    if (status !== 'X' && !skippedChannels.includes(channel)) {
      nickNameIdsList?.push(obj?.id);
    }
  });
  return nickNameIdsList;
};

export const getInitialChannels = nickNameList => {
  const filteredList = _filter(nickNameList, name => {
    const channel = name?.id?.split('-')?.[0];
    let status = name?.status || 'A';
    if (status !== 'X' && !skippedChannels.includes(channel)) {
      return name;
    }
  });
  return filteredList;
};

export const getNickNameValue = (channelObjList, nickNameID, defaultVal) => {
  let nickNameValue = '';
  if (!_isEmpty(channelObjList)) {
    for (let i = 0; i < channelObjList.length; i++) {
      let channelObj = channelObjList[i];
      if (channelObj?.id === nickNameID) {
        nickNameValue = channelObj?.value;
        break;
      }
    }
  }
  if (_isEmpty(nickNameValue) && defaultVal) {
    nickNameValue = defaultVal.split('-')[1];
  }
  return nickNameValue;
};

// ReAuth Supported Channels
export const reAuthSupportedChannelList = [
  'shopee',
  'shopeeGlobal',
  'lazada',
  'facebookAds',
  'amazon',
  'eBay',
  'etsy',
  'googleAds',
  'flipkart',
  'tiktokAds',
  'salesforce',
  'tiktok',
  'nykaa',
  'myntra',
  'ajio',
  'easyEcom',
  'unicommerce',
  'magento',
  'meesho',
  'tataCliq'
];

export const getChannelExpiryTimeMap = (
  accountDetails,
  channelsNeedToUpgradeVersion,
  channelCountryCodeMap,
  skipInactiveChannels = true,
  sourceChannelMap = {}
) => {
  let channelExpiryTimeMap = {};
  let channelPermission = accountDetails?.userDetails?.channelPermissions || [];
  for (let i in reAuthSupportedChannelList) {
    let channelList = accountDetails[reAuthSupportedChannelList[i]];
    for (let j in channelList) {
      let channelObject = channelList[j];
      let nickNameID = channelObject.nickName.id;
      let sourceChannelName = channelObject?.sourceChannelName || '';
      if (!_isUndefined(channelObject?.sourceChannelName) && !_isEmpty(channelObject?.sourceChannelName)) {
        if (sourceChannelMap?.[sourceChannelName]) {
          let nameIdlist = sourceChannelMap?.[sourceChannelName];
          nameIdlist?.push(nickNameID);
        } else {
          sourceChannelMap[sourceChannelName] = [nickNameID];
        }
      }
      if (!_isEmpty(channelPermission) && !channelPermission?.includes(nickNameID)) continue;
      let channel = nickNameID.split('-')[0];
      if (channelObject.status !== undefined && channelObject.status === 'X' && skipInactiveChannels) {
        continue;
      } else if (channelObject?.status === 'R') {
        channelExpiryTimeMap[nickNameID] = -1;
      } else if (['shopee', 'etsy', 'amazon', 'shopeeGlobal'].includes(channel)) {
        let isReauthNeeded = false;
        if (channelObject.erpRefreshTokenUpdatedTime) {
          if (channel === 'shopee' || channel === 'shopeeGlobal') {
            const status = _get(channelObject, 'status', 'A');
            if (status === 'A' || status === 'X' || status === 'R') {
              let erpRefreshTokenUpdatedTime = channelObject.erpRefreshTokenUpdatedTime;
              let dayDiff = calculateDaysDiffrence(erpRefreshTokenUpdatedTime * 1000, new Date().getTime());
              if (dayDiff > 1) {
                isReauthNeeded = true;
              }
              if (channelObject.expiryTime !== undefined) {
                let expiryTime = channelObject.expiryTime;
                dayDiff = calculateDaysDiffrence(new Date().getTime(), expiryTime * 1000);
                if (dayDiff <= 6) {
                  channelExpiryTimeMap[nickNameID] = dayDiff;
                }
              }
            }
          } else if (channel === 'amazon') {
            let erpRefreshTokenUpdatedTime = channelObject.erpRefreshTokenUpdatedTime;
            let dayDiff = calculateDaysDiffrence(erpRefreshTokenUpdatedTime * 1000, new Date().getTime());
            if (dayDiff > 1) {
              isReauthNeeded = true;
              channelCountryCodeMap[nickNameID] = channelObject?.countryCode;
            }
          }
        } else if (channel === 'amazon') {
          // For Amazon, if `erpRefreshTokenUpdatedTime` is not available, reauthentication is required.
          channelCountryCodeMap[nickNameID] = channelObject?.countryCode;
          channelExpiryTimeMap[nickNameID] = -1;
        } else if (channelObject.refreshTokenUpdatedTime) {
          //For etsy
          let dayDiff = calculateDaysDiffrence(channelObject.refreshTokenUpdatedTime * 1000, new Date().getTime());
          if (dayDiff > 1) {
            isReauthNeeded = true;
          }
        } else {
          isReauthNeeded = true;
        }
        if (isReauthNeeded && !_isEmpty(channelExpiryTimeMap?.[nickNameID])) channelExpiryTimeMap[nickNameID] = -1;
      } else if (
        [
          'facebookAds',
          'googleAds',
          'flipkart',
          'tiktokAds',
          'salesforce',
          'nykaa',
          'myntra',
          'ajio',
          'unicommerce',
          'easyEcom',
          'magento',
          'meesho',
          'tataCliq'
        ].includes(channel)
      ) {
        if (channelObject?.isReauthRequired) {
          channelExpiryTimeMap[nickNameID] = -1;
        }
      } else {
        let expiryTime = '';
        if (channelObject.postHelper !== undefined && channelObject.postHelper.refreshTokenExipryDate !== undefined) {
          expiryTime = channelObject.postHelper.refreshTokenExipryDate;
        } else if (channelObject.expiryTime !== undefined) {
          expiryTime = channelObject.expiryTime;
        } else if (
          channelObject.postHelper !== undefined &&
          channelObject.postHelper.refreshTokenExpiryDate !== undefined
        ) {
          expiryTime = channelObject.postHelper.refreshTokenExpiryDate;
        } else if (
          channelObject.postHelper !== undefined &&
          channelObject.postHelper.accessTokenExpiryDate !== undefined
        ) {
          expiryTime = channelObject.postHelper.accessTokenExpiryDate;
        } else if (channelObject.authExpiryTime !== undefined && channelObject.authExpiryTime.$date !== undefined) {
          const isoDate = new Date(channelObject.authExpiryTime.$date);
          expiryTime = isoDate.getTime() / 1000;
        }
        let dayDiff = calculateDaysDiffrence(new Date().getTime(), expiryTime * 1000);
        if (dayDiff <= 7) {
          channelExpiryTimeMap[nickNameID] = dayDiff;
          channelCountryCodeMap[nickNameID] = channelObject?.countryCode;
        }
      }
    }
  }
  return channelExpiryTimeMap;
};

export const getChannelExpiryResultMap = accountDetails => {
  let channelsNeedToUpgradeVersion = [];
  let channelCountryCodeMap = {};
  let channelExpiryTimeMap = getChannelExpiryTimeMap(
    accountDetails,
    channelsNeedToUpgradeVersion,
    channelCountryCodeMap
  );
  let finalMap = {};
  channelExpiryTimeMap = Object.fromEntries(Object.entries(channelExpiryTimeMap).sort(([, a], [, b]) => a - b));
  let nickNameIdList = Object.keys(channelExpiryTimeMap);
  for (let i in nickNameIdList) {
    let nickNameID = nickNameIdList[i];
    finalMap[nickNameID] = channelCountryCodeMap[nickNameID] || 'SG';
  }
  return finalMap;
};

export const addNewLinkedAccount = (channel, payload, dispatch) => {
  const apiResponse = dispatch(initiateChannel(channel, payload));
  apiResponse.then(response => {
    if (response?.hasError) {
      message.error(t('GRAAS_FAIL_TO_LOAD_DATA_GRAAS'));
    } else {
      window.open(
        response?.data?.url,
        'popup',
        'width=700,height=500,toolbar=0,menubar=0,location=0,status=1,scrollbars=1,resizable=1,left=0,top=0'
      );
    }
  });
};

const formReauth = (nickNameID, payload) => {
  let site = nickNameID.split('-')[0];
  window.open(
    `${window.location.origin}/connect/${site}?nickNameID=${nickNameID}&isAccountReauthentication=true`,
    '_self'
  );
};

export const upgradeChannelAccount = (nickNameID, countryCode, dispatch, actionNeeded = false) => {
  var channel = nickNameID.split('-')[0];
  if (actionNeeded && inCompleteActionRequiredChannels?.includes(channel)) {
    window.open(`${window.location.origin}/connect/${channel}?nickNameID=${nickNameID}`, '_self');
  }

  if (channel === 'lazada' && countryCode !== 'GLOBAL') {
    let targetURL = '';
    if (countryCode === 'SG') {
      targetURL = process.env.REACT_APP_LAZADA_AUTHORIZATION_SG_URL;
    } else if (countryCode === 'MY') {
      targetURL = process.env.REACT_APP_LAZADA_AUTHORIZATION_MY_URL;
    } else if (countryCode === 'ID') {
      targetURL = process.env.REACT_APP_LAZADA_AUTHORIZATION_ID_URL;
    } else if (countryCode === 'PH') {
      targetURL = process.env.REACT_APP_LAZADA_AUTHORIZATION_PH_URL;
    } else if (countryCode === 'TH') {
      targetURL = process.env.REACT_APP_LAZADA_AUTHORIZATION_TH_URL;
    } else if (countryCode === 'VN') {
      targetURL = process.env.REACT_APP_LAZADA_AUTHORIZATION_VN_URL;
    }
    window.open(targetURL, '_blank');
    return;
  }

  var payload = {
    requestFrom: 'graas',
    nickNameID: nickNameID
  };
  if (channel === 'shopee' || channel === 'shopeeGlobal') {
    payload.apiVersion = 2;
  } else if (channel === 'etsy') {
    payload.apiVersion = 3;
  } else if (channel === 'lazada') {
    payload.isUpgrade = true;
  } else if (channel === 'eBay') {
    payload.isReauthenticate = true;
  } else if (['facebookAds', 'googleAds', 'tiktok', 'flipkart', 'tiktokAds'].includes(channel)) {
    payload.isAccountReauthentication = true;
  } else if (channel === 'amazon') {
    payload.isAccountReauthentication = true;
    payload.countryCode = countryCode;
  }
  if (
    ['salesforce', 'nykaa', 'myntra', 'magento', 'ajio', 'unicommerce', 'easyEcom', 'meesho', 'tataCliq'].includes(
      channel
    )
  ) {
    formReauth(nickNameID);
  } else {
    addNewLinkedAccount(nickNameID.split('-')[0], payload, dispatch);
  }
};

export const isEditAllowed = (allowEdit, setShowUpgrade) => {
  setShowUpgrade(false);
  if (!allowEdit) {
    setShowUpgrade(true);
  }
};

export const getExpiryTimeContent = timeDiff => {
  let content = '';
  if (parseInt(timeDiff) === 0 && !timeDiff.toString().includes('-')) {
    content = t('GRAAS_EXPIRY_MSG_1_GRAAS');
  } else if (timeDiff.toString().includes('-')) {
    content = t('GRAAS_EXPIRY_MSG_2_GRAAS');
  } else if (timeDiff === 1) {
    content = parseInt(timeDiff) + ' ' + t('GRAAS_EXPIRY_MSG_3_GRAAS');
  } else {
    content = parseInt(timeDiff) + ' ' + t('GRAAS_EXPIRY_MSG_4_GRAAS');
  }
  return content;
};

export const calculateDaysDiffrence = (startDate, endDate) => {
  const startMoment = moment(startDate);
  const endMoment = moment(endDate);
  const diffDays = endMoment.diff(startMoment, 'days');
  return diffDays;
};

export const getDateRangeForLastTwentyFourHours = timeZone => {
  const now = moment().utc();
  const twentyFourHoursAgo = now.clone().subtract(24, 'hours');
  const endDate = now.clone().tz(timeZone).format('YYYY-MM-DDTHH:mm:ss.SSS');
  const startDate = twentyFourHoursAgo.tz(timeZone).format('YYYY-MM-DDTHH:mm:ss.SSS');
  return [startDate, endDate];
};

export const getCompareRangeForLastTwentyFourHours = timeZone => {
  const now = moment().utc();
  const twentyFourHoursAgo = now.subtract(24, 'hours');
  const endDate = twentyFourHoursAgo.tz(timeZone).format('YYYY-MM-DDTHH:mm:ss.SSS');
  const dayBeforeYesterday = twentyFourHoursAgo.subtract(24, 'hours');
  const startDate = dayBeforeYesterday.tz(timeZone).format('YYYY-MM-DDTHH:mm:ss.SSS');
  return [startDate, endDate];
};

export const getDateBeforeTwentyFourHours = () => {
  const now = moment();
  const twentyFourHoursAgo = now.clone().subtract(24, 'hours');
  return twentyFourHoursAgo.format('DD/MM/YYYYTHH:mm:ss');
};

export const getCurrentDate = () => {
  const now = moment();
  return now.format('DD/MM/YYYYTHH:mm:ss');
};

export const getRedirectionUrl = (tag, combinedTags) => {
  let redirectTo = '/profile/business-profile?type=subscription';
  const parsed = queryString.parse(window.location.search);
  if (!_isEmpty(parsed?.redirectTo)) {
    redirectTo = window.location.href.split('redirectTo=')?.[1] || parsed?.redirectTo;
  }
  return redirectTo;
};

export const validateMenuPermission = (permissionMenus, userName, merchantID, setIsNeedToUpgrade) => {
  const isSupportUser = userName?.includes('[admin]');
  const currentUrlPathName = window.location.pathname;
  setIsNeedToUpgrade(true);
  if (!isSupportUser || (isSupportUser && urlPermissionEnabledAccountForSupportUser.includes(merchantID))) {
    for (let i in permissionMenus) {
      let menuItem = permissionMenus[i];
      if (_isEmpty(menuItem?.paths)) {
        continue;
      }
      let path = menuItem?.basePath || menuItem?.path;
      const alternatePath = menuItem?.alternatePath || '';
      if (
        currentUrlPathName.includes(path) ||
        (!_isEmpty(alternatePath) && currentUrlPathName.includes(alternatePath))
      ) {
        if (!_isEmpty(menuItem?.paths)) {
          let pathsList = menuItem?.paths;
          for (let j in pathsList) {
            let pathItem = pathsList?.[j];
            if (pathItem.includes('{id}')) {
              let rawPathList = pathItem.split('{id}');
              let isRawPathMatched = true;
              for (let k in rawPathList) {
                if (!currentUrlPathName.includes(rawPathList[k])) {
                  isRawPathMatched = false;
                  break;
                }
              }
              if (isRawPathMatched) {
                let pathItemsList = pathItem.split('/');
                let UrlPathItemList = currentUrlPathName.split('/');
                const compareArrays = (a, b) => {
                  // Comparing each element of your array
                  for (var z = 0; z < a.length; z++) {
                    if (a[z] !== '{id}' && a[z] !== b[z]) {
                      return false;
                    }
                  }
                  return true;
                };
                setIsNeedToUpgrade(!compareArrays(pathItemsList, UrlPathItemList));
                break;
              }
            } else if (pathItem === currentUrlPathName) {
              setIsNeedToUpgrade(false);
              break;
            }
          }
        }
        break;
      }
    }
  } else {
    setIsNeedToUpgrade(false);
  }
};

export const renderHTML = rawHTML => {
  if (rawHTML === undefined || rawHTML === '') return rawHTML;
  return <span className='c-heading bold sm mb-0' dangerouslySetInnerHTML={{ __html: rawHTML }} />;
};

export const renderNormalHTMLText = rawHTML => {
  if (rawHTML === undefined || rawHTML === '') return rawHTML;
  return <span dangerouslySetInnerHTML={{ __html: rawHTML }} />;
};

export const firstLetterToLower = key => {
  return key.charAt(0).toLowerCase() + key.slice(1);
};

export const getInsightsViewedCount = fieldName => {
  if (localStorage.getItem(fieldName) !== null) {
    return localStorage.getItem(fieldName);
  }
  return 1;
};

export const setInsightsViewedCount = (fieldName, count) => {
  localStorage.setItem(fieldName, count);
};

export const triggerViewedInsightsCount = (fieldName, viewedInsightsCount, userData, loadedInsightsId) => {
  if (loadedInsightsId !== undefined) {
    let offsetValue = 1;
    let impressionValue = viewedInsightsCount % offsetValue;
    if (impressionValue === 0) {
      let apiUrl = `${apiServices['insights']}/services/viewedInsights`;
      let apiPayload = {
        accountNumber: userData?.accountNumber,
        userID: userData?.userId,
        insightIDs: loadedInsightsId
      };
      updateDataFromApiAction(apiUrl, apiPayload);
    }
    let incrementValue = parseInt(viewedInsightsCount) + 1;
    setInsightsViewedCount(fieldName, incrementValue);
  }
};

export const getRecommendationsViewedCount = fieldName => {
  if (localStorage.getItem(fieldName) !== null) {
    return localStorage.getItem(fieldName);
  }
  return 1;
};

export const setRecommendationsViewedCount = (fieldName, count) => {
  localStorage.setItem(fieldName, count);
};

export const triggerViewedRecommendationsCount = (fieldName, viewedRecommendationsCount, userData, loadedRecosId) => {
  if (loadedRecosId !== undefined) {
    let offsetValue = 1;
    let impressionValue = viewedRecommendationsCount % offsetValue;
    if (impressionValue === 0) {
      let apiUrl = `${apiServices['recommendations']}/services/viewedRecommendations`;
      let apiPayload = {
        storeCode: userData?.merchantID,
        userID: userData?.userId,
        recoIDs: loadedRecosId
      };
      updateDataFromApiAction(apiUrl, apiPayload);
    }
    let incrementValue = parseInt(viewedRecommendationsCount) + 1;
    setRecommendationsViewedCount(fieldName, incrementValue);
  }
};

export const constructRecommendationsIDList = data => {
  let recoIDsList = [];
  if (data instanceof Array) {
    for (let index in data) {
      if (data[index]?.reco_id) {
        recoIDsList?.push(data[index]?.reco_id);
      }
    }
  }
  return recoIDsList;
};

export const notificationFeedIdentifierMap = [
  {
    storeId: 'all',
    query: { feedIdentifier: ['all', 'system', 'comments'] }
  },
  {
    storeId: 'system',
    query: { feedIdentifier: 'system' }
  },
  {
    storeId: 'comments',
    query: { feedIdentifier: 'comments' }
  }
];

export const notificationTabMap = [
  {
    name: 'All',
    storeId: 'all'
  },
  {
    name: 'System',
    storeId: 'system'
  },
  {
    name: 'Comments',
    storeId: 'comments'
  }
];

export const marketingAdsChannels = ['facebookAds', 'googleAds', 'amazonAds', 'tiktokAds'];

export const extractSupportedChannels = [
  'lazada',
  'shopee',
  'tokopedia',
  'tiktok',
  'flipkart',
  'amazon',
  'blibli',
  'zalora',
  'tiki',
  'elevenStreet',
  'etsy',
  'bukalapak',
  'qoo10',
  'eBay',
  'nykaa',
  'myntra',
  'ajio',
  'shopeeGlobal',
  'zaloraGlobal',
  'shopify',
  'magento',
  'wooCommerce',
  'prestaShop',
  'salesforce',
  'amazonVendorCentral',
  'myntraSjit',
  'googleAds',
  'facebookAds',
  'amazonAds',
  'tiktokAds',
  'meesho',
  'tataCliq'
];

export const capitalizeFirst = str => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const calculatePercentageDifference = (amount1, amount2) => {
  const difference = amount2 - amount1;
  const parsedValue = !isNaN(amount1) && amount1 !== 0 ? ((difference / amount1) * 100).toFixed(2) : 0;
  return parsedValue - Math.floor(parsedValue) === 0 ? Math.floor(parsedValue) : parsedValue;
};

// --- Marketing supported channels (Marketplaces and D2C)
export const marketplaceAndD2CChannels = [
  'lazada',
  'shopee',
  'tokopedia',
  'tiki',
  'flipkart',
  'amazon',
  'blibli',
  'zalora',
  'tiktok',
  'elevenStreet',
  'etsy',
  'bukalapak',
  'qoo10',
  'eBay',
  'nykaa',
  'myntra',
  'shopify',
  'magento',
  'wooCommerce',
  'prestaShop',
  'salesforce',
  'ajio',
  'meesho',
  'tataCliq'
];

export const getAvailableChannelNickNameIDs = (nickNames, type, pageType) => {
  let nickNameIds = [];
  for (let index in nickNames) {
    let nickNameObject = nickNames[index];
    if (!nickNameObject?.status || nickNameObject.status !== 'X') {
      if (nickNameObject?.id) {
        if (pageType != undefined && pageType === 'marketingDeepDive') {
          const marketingChannels = [
            'amazonAds',
            'googleAds',
            'facebookAds',
            'shopee',
            'lazada',
            'amazon',
            'flipkart',
            'tiktokAds'
          ];
          let channelName = nickNameObject.id.split('-')[0];
          if (marketingChannels.includes(channelName)) {
            nickNameIds?.push(nickNameObject.id);
          }
        } else {
          nickNameIds?.push(nickNameObject.id);
        }
      }
    }
  }
  return type === 'recos' ? nickNameIds : nickNameIds.join(',');
};

export const getActiveNickNameIds = nicknames => {
  let activeChannels = [];
  _forEach(nicknames, obj => {
    if (_isEmpty(obj?.status) || ['A', 'R'].includes(obj?.status)) {
      activeChannels?.push(obj?.id);
    }
  });
  return activeChannels;
};

const dashboardNames = {
  INDIAN: ['combined-ws', 'marketing-ws', 'custom_dashboard'],
  OTHER: ['ecommerce-ws', 'marketing-ws', 'custom_dashboard', 'finance-ws']
};

export const shouldShowDashboard = (dashboardName, countryCode) => {
  if (['US', 'IN'].includes(countryCode)) {
    return dashboardNames.INDIAN.includes(dashboardName);
  } else {
    return dashboardNames.OTHER.includes(dashboardName);
  }
};

export const shouldShowWorkspaceDashboard = (dashboardName, userData, WorkSpaceState) => {
  const { countryCode } = userData;
  const activeDashboards = WorkSpaceState?.activeDashboards || [];

  const combinedDashboardExists =
    ['US', 'IN'].includes(countryCode) && _some(activeDashboards, { code: 'combined-ws' });

  const dashboardList = combinedDashboardExists ? dashboardNames.INDIAN : dashboardNames.OTHER;

  return (
    dashboardList.includes(dashboardName) ||
    _some(['custom_template_', 'custom_dashboard_'], prefix => _startsWith(dashboardName, prefix))
  );
};

// --- Set values in cookies
export const setCookies = (key, value, expiryValue, expiryTime) => {
  let time = 0;
  if (expiryTime === 'day') {
    time = 24 * 60 * 60 * 1000;
  } else if (expiryTime === 'hour') {
    time = 60 * 60 * 1000;
  }
  let expires = new Date();
  expires.setTime(expires.getTime() + time * expiryValue);
  const isDemoHost = getIsDemoHost();
  if (isDemoHost) {
    document.cookie = `demo-${key}=${value};expires=${expires.toUTCString()};path=/`;
  } else {
    document.cookie = `${key}=${value};expires=${expires.toUTCString()};domain=${process.env.NODE_ENV === 'development' ? 'localhost' : process.env.REACT_APP_COOKIE_PATH
      };path=/`;
  }
};

// --- Clear values from cookies
export const removeCookies = key => {
  setCookies(key, '', 0, 'hour');
};

export const getDefaultMenuPath = (menus, orderedMenu) => {
  let path = '';
  for (let i in orderedMenu) {
    let id = orderedMenu[i];
    let filteredMenu = _filter(menus, menuObject => {
      let isEnabled = true;
      if (!_isUndefined(menuObject?.isEnabled)) {
        isEnabled = menuObject?.isEnabled;
      }
      return isEnabled && menuObject?.id === id;
    });
    _forEach(filteredMenu, menu => {
      path = menu?.basePath || menu?.path || '';
      if (!_isEmpty(path)) {
        return;
      }
    });
    if (!_isEmpty(path)) {
      break;
    }
  }
  return path;
};

export const getFirstActiveMenu = (userMenus, availableMenus) => {
  let path = '/home';
  for (let i in availableMenus) {
    let menuItem = _find(userMenus, item => availableMenus?.[i] === item?.id && item?.isEnabled) || {};
    if (!_isEmpty(menuItem)) {
      path = menuItem?.path || menuItem?.basePath;
      break;
    }
  }
  return path;
};

export const getMenuPath = (
  menuItem,
  availableMenus = [],
  isBillPlanEnabled = false,
  isNewMenuStructureEnabled = false
) => {
  let path = '';
  if (!_isEmpty(menuItem?.subMenu)) {
    const subMenuArray = menuItem?.subMenu;
    for (let i in subMenuArray) {
      const subMenuObj = subMenuArray[i];
      if (!_isEmpty(subMenuObj?.menu)) {
        const subMenuInnerMenu = subMenuObj?.menu;
        if (!_isEmpty(availableMenus) && !isBillPlanEnabled && isNewMenuStructureEnabled) {
          for (let j in subMenuInnerMenu) {
            const subInnerMenuObj = subMenuInnerMenu[j];
            if (availableMenus.includes(subInnerMenuObj?.id)) {
              path = subInnerMenuObj?.path;
              break;
            }
          }
        } else {
          path = subMenuInnerMenu?.[0]?.path;
        }
      } else if (!_isEmpty(subMenuObj?.path)) {
        path = subMenuObj?.path;
      }
      if (!_isEmpty(path)) {
        break;
      }
    }
  } else {
    path = menuItem?.path || menuItem?.basePath;
  }
  return path;
};

export const userPermissionEnabledChannels = [
  'eBay',
  'amazon',
  'shopify',
  'flipkart',
  'etsy',
  'magento',
  'lazada',
  'qoo10',
  'shopee',
  'elevenStreet',
  'offline',
  'zalora',
  'jd',
  'bukalapak',
  'tokopedia',
  'blibli',
  'wooCommerce',
  'tiki',
  'prestaShop',
  'tiktok',
  'facebookAds',
  'googleAds',
  'amazonAds',
  'salesforceB2B',
  'salesforce',
  'capillary',
  'myntra',
  'nykaa',
  'shopeeGlobal',
  'googleAnalytics',
  'googleSearchConsole',
  'semrush',
  'tiktokAds'
];

export const compareQueryHandledCharts = ['MultiAxisLine', 'table'];

export const getFormedNickName = (nickNameObjectList, nickNameID) => {
  let filteredNickNameObject = _filter(nickNameObjectList, nickNameObject => nickNameObject?.id === nickNameID);
  if (filteredNickNameObject?.length > 0) {
    return filteredNickNameObject[0]?.id?.split('-')?.[0] + '-' + filteredNickNameObject[0]?.value;
  }
  return nickNameID;
};

export const capitalizeFirstLetter = string => {
  return string.replace(/^\w/, c => c.toUpperCase());
};

export const getOAuthQueryParamenters = () => {
  const parsedQueryString = queryString.parse(window.location.search);
  if (
    !_isEmpty(parsedQueryString?.shop) &&
    !_isEmpty(parsedQueryString?.hmac) &&
    !_isEmpty(parsedQueryString?.timestamp) &&
    !_isEmpty(parsedQueryString?.host) &&
    _isEmpty(parsedQueryString?.session)
    // if session contain it will just open app from shopify portal(Not app install)
  ) {
    return window.location.search;
  } else if (
    !_isEmpty(parsedQueryString?.code) &&
    !_isEmpty(parsedQueryString?.state) &&
    !_isEmpty(parsedQueryString?.action)
  ) {
    // for lazada connect
    return window.location.search;
  } else {
    return '';
  }
};

export const updateQueryParam = (navigate, params, queryParmsObject) => {
  _map(Object.keys(queryParmsObject), key => params.set(key, queryParmsObject[key]));
  navigate({ search: params.toString() });
};

export const historicalDataEnabledChannels = [
  'lazada',
  'shopee',
  'shopify',
  'tokopedia',
  'blibli',
  'magento',
  'wooCommerce',
  'facebookAds',
  'googleAds',
  'bukalapak',
  'flipkart',
  'tiktok',
  'zalora',
  'amazon',
  'tiktokAds',
  'amazonAds',
  'googleAnalytics',
  'salesforce',
  'myntra',
  'ajio',
  'nykaa',
  'meesho',
  'tataCliq',
  'zepto',
  'instamart'
];

// historical data in months
export const historicalDataSyncTime = {
  lazada: 3,
  shopee: 3,
  shopify: 18,
  tokopedia: 3,
  magento: 3,
  woocommerce: 3,
  tiktok: 3,
  blibli: 3,
  zalora: 3,
  amazon: 3,
  bukalapak: 18,
  salesforce: 3,
  flipkart: 3,
  facebookAds: 18,
  googleAds: 18,
  amazonAds: 12,
  tiktokAds: 12,
  googleAnalytics: 12,
  lazadaAds: 12,
  nykaa: 3,
  ajio: 3,
  myntra: 3,
  meesho: 3,
  tataCliq: 3
};

//-- Clear modal states and remove styles
export const onCloseModal = () => {
  document.getElementsByTagName('body')[0].removeAttribute('style');
};

export function componentLoaderPromise(lazyComponent, attemptsLefts) {
  return new Promise((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch(error => {
        let attemptsLeft = attemptsLefts ? attemptsLefts : 1;
        setTimeout(() => {
          if (attemptsLeft === 0) {
            reject(error);
            return;
          }
          componentLoaderPromise(lazyComponent, attemptsLeft - 1).then(resolve, reject);
        }, 1500);
      });
  });
}

export function ConvertUTToDate(timeStamp) {
  let a = new Date(timeStamp * 1000);
  let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  let year = a.getFullYear();
  let month = months[a.getMonth()];
  let date = a.getDate();
  let time = date + ' ' + month + ' ' + year;
  return time;
}

export const checkBillPlanPermission = (
  herfLink,
  navigationMenus,
  currentUrlPathName,
  setIsNeedToUpgrade,
  setAllowEdit,
  filterDashboards
) => {
  if (setIsNeedToUpgrade !== null) setIsNeedToUpgrade(false);
  const userMenus = navigationMenus?.userMenu;
  let pathNames = herfLink.split(window.location.origin);
  let pathParamList = [];
  if (!pathNames?.[1].includes('?') && pathNames?.[1].includes('workspace')) {
    if (_isEmpty(filterDashboards)) {
      if (setIsNeedToUpgrade !== null) setIsNeedToUpgrade(true);
      return;
    }
  }
  if (pathNames?.[1].includes('?')) {
    let pathParamsNames = pathNames[1].split('?');
    pathParamList = pathParamsNames[1].split('&');
  } else {
    if (setIsNeedToUpgrade !== null) setIsNeedToUpgrade(false);
    return;
  }
  let matchFlag = false;
  for (let i in userMenus) {
    let menu = userMenus[i];
    let paths = userMenus[i]?.paths;
    if (menu?.basePath === currentUrlPathName) {
      for (let j in paths) {
        let pathItem = paths[j];
        if (pathItem.includes('?') && !matchFlag) {
          let pathItemNames = pathItem.split('?');
          let configParamList = pathItemNames[1].split('&');
          let finalList = configParamList.filter(val => !pathParamList.includes(val));
          if (finalList.length === 0) {
            matchFlag = true;
            if (setIsNeedToUpgrade !== null) setIsNeedToUpgrade(false);
          }
        } else if (pathItem.includes('edit')) {
          if (setIsNeedToUpgrade !== null) setAllowEdit(true);
        } else {
          if (setIsNeedToUpgrade !== null) setIsNeedToUpgrade(false);
        }
      }
      if (!matchFlag && pathNames?.[1].includes('/analyze/workspace')) {
        let isFound = '';
        if (pathNames?.[1].includes('custom_dashboard')) {
          // if user has access to custom_dashboard, then only we are giving access to all custom_dashboards
          isFound = _find(paths, item => item?.includes('custom_dashboard')) || '';
        } else if (pathNames?.[1].includes('custom_template_')) {
          // if user trying to access custom_template, then we are giving access to all custom_templates
          isFound = _find(pathParamList, item => item?.includes('custom_template_')) || '';
        }
        if (!_isEmpty(isFound)) {
          matchFlag = true;
          if (setIsNeedToUpgrade !== null) {
            setIsNeedToUpgrade(false);
            setAllowEdit(true);
          }
        }
      }
      break;
    }
  }
  if (!matchFlag && setIsNeedToUpgrade !== null) setIsNeedToUpgrade(true);
};

//* get metric definition
export const getGraasMetricDefinition = (metricDefinitionData, key) => {
  if (!_isEmpty(metricDefinitionData)) {
    const metricDefinitionObject = _find(
      metricDefinitionData,
      item => item?.METRIC_UNIVERSAL_NAME === key && item?.SOURCE === 'GRAAS'
    );
    if (!_isEmpty(metricDefinitionObject)) {
      return metricDefinitionObject['METRIC_SOURCE_DEFINTION'];
    }
  }
};

// intergartion multiple step channel list
export const connectMultipleStepChannel = ['facebookAds', 'googleAds', 'amazonAds', 'googleAnalytics', 'tiktokAds'];

export const mouseflowTrack = (data, customeTag) => {
  if (process.env.REACT_APP_MOUSEFLOW_KEY && process.env.NODE_ENV === 'production' && window._mfq) {
    if (customeTag) {
      window._mfq?.push(['tag', customeTag]);
    } else {
      window._mfq?.push(['tag', data?.storeCode]);
    }
    window._mfq?.push(['setVariable', 'userName', data?.username]);
    window._mfq?.push(['setVariable', 'email', data?.email]);
    window._mfq?.push(['setVariable', 'sellerID', data?.storeCode]);
    if (data?.isDemoAccount) {
      window._mfq?.push(['tag', 'isDemoAccount']);
    }
    if (data?.username?.indexOf('admin') > 0) {
      window._mfq?.push(['tag', 'admin']);
    } else {
      window._mfq?.push(['tag', 'seller']);
    }
  }
};

export const deepDiveReportEnabledChannel = ['shopee', 'lazada', 'tokopedia', 'amazon', 'flipkart'];
export const getBillPlanExpiryDateDifference = (freeTrailExpiryTime, timeZone) => {
  const givenDate = moment.tz(freeTrailExpiryTime * 1000, timeZone).startOf('day');
  const today = moment().tz(timeZone).startOf('day');
  const diffInDays = givenDate.diff(today, 'days');
  return diffInDays >= 0 ? diffInDays + 1 : diffInDays;
};

export const getActivationDate = timeZone => {
  const dateInTimeZone = new Date().toLocaleString('en-US', { timeZone });
  const date = new Date(dateInTimeZone);
  return Math.floor(date.getTime() / 1000);
};

export const isBillPlanDesignRequired = (overallBillPlanDetails, billPlanDetails) => {
  if (overallBillPlanDetails?.length === 0) {
    return true;
  }
  const totalBillPlanIds = overallBillPlanDetails.map(item => item?.billPlanID) || [];
  const activeBillPlanIds =
    _filter(billPlanDetails?.billPlanDetails, item => item?.status.toUpperCase() === 'A').map(
      item => item?.billPlanID
    ) || [];
  const inActiveBillPlanIds = _filter(totalBillPlanIds, item => !activeBillPlanIds.includes(item)) || [];
  return inActiveBillPlanIds.length > 0;
};

export const editChannelJson = {
  '99SME': {
    headerRows: [
      'itemTitle',
      'itemDescription',
      'shortDescription',
      'itemAmount',
      'salePrice',
      'noOfItem',
      'categoryID',
      'imageURI',
      'weight(kg)',
      'packageHeight(cm)',
      'packageLength(cm)',
      'packageWidth(cm)'
    ]
  },
  blibli: {
    headerRows: [
      'itemTitle',
      'itemDescription',
      'itemAmount',
      'salePrice',
      'saleStartDate',
      'saleEndDate',
      'noOfItem',
      'imageURI',
      'categoryID',
      'shippingServiceDetails',
      'weight(kg)',
      'packageLength(cm)',
      'packageWidth(cm)',
      'packageHeight(cm)',
      'brand',
      'upc',
      'videoUrl',
      'productType',
      'itemSpecifics'
    ]
  },
  bukalapak: {
    headerRows: [
      'itemTitle',
      'itemDescription',
      'itemAmount',
      'discountedPrice',
      'saleStartDate',
      'saleEndDate',
      'noOfItem',
      'imageURI',
      'categoryID',
      'packageWeight(gram)',
      'itemSpecifics'
    ]
  },
  eBay: {
    headerRows: [
      'customLabel',
      'itemTitle',
      'itemDescription',
      'UPC',
      'EAN',
      'auction',
      'bidStartAmount',
      'reserveAmount',
      'itemAmount',
      'minimumBestOfferPrice',
      'bestOfferAutoAcceptPrice',
      'bestOffer',
      'noOfItem',
      'categoryID',
      'imageURI',
      'storeCategoryID',
      'conditionID',
      'itemDuration',
      'paymentPolicy',
      'shippingPolicy',
      'returnPolicy',
      'relist',
      'privateNotes',
      'imageVariationTitle',
      'privateListing',
      'videoURL',
      'hitCounterCodeType',
      'themeID',
      'itemPostalCode',
      'itemCountryCode',
      'itemLocation',
      'itemSpecifics'
    ]
  },
  elevenStreet: {
    headerRows: [
      'itemTitle',
      'itemDescription',
      'itemAmount',
      'salePrice',
      'saleStartDate',
      'saleEndDate',
      'noOfItem',
      'itemDurationStartDate',
      'itemDurationEndDate',
      'adultItem',
      'categoryID',
      'imageURI',
      'weight(kg)',
      'itemWidth(cm)',
      'itemLength(cm)',
      'itemHeight(cm)',
      'warrantyType',
      'warrantyPeriod',
      'expireDate',
      'productFeatures',
      'packageWeight(kg)',
      'packageWidth(cm)',
      'packageLength(cm)',
      'packageHeight(cm)',
      'promotionText',
      'itemSpecifics'
    ]
  },
  etsy: {
    headerRows: [
      'itemTitle',
      'itemDescription',
      'itemAmount',
      'noOfItem',
      'categoryID',
      'imageURI',
      'whoMade',
      'whenMade',
      'whatIsIt',
      'tags',
      'materials',
      'recipient',
      'occasion',
      'style',
      'shippingTemplate',
      'shopSectionId'
    ]
  },
  jd: {
    headerRows: [
      'itemTitle',
      'itemDescription',
      'retailAmount',
      'itemAmount',
      'noOfItem',
      'categoryID',
      'imageURI',
      'weight(kg)',
      'packageLength(cm)',
      'packageWidth(cm)',
      'packageHeight(cm)',
      'packageWeight(kg)',
      'packageContent',
      'tags',
      'warrantyPeriod',
      'brand',
      'isCod',
      'itemSpecifics'
    ]
  },
  lazada: {
    headerRows: [
      'itemTitle',
      'itemDescription',
      'shortDescription',
      'itemAmount',
      'salePrice',
      'saleStartDate',
      'saleEndDate',
      'noOfItem',
      'categoryID',
      'imageURI',
      'brand',
      'model',
      'warrantyType',
      'packageWeight(kg)',
      'packageHeight(cm)',
      'packageLength(cm)',
      'packageWidth(cm)',
      'packageContent',
      'itemSpecifics',
      'templateAttribute'
    ]
  },
  qoo10: {
    headerRows: [
      'itemTitle',
      'itemDescription',
      'isOption',
      'retailAmount',
      'Qprice',
      'salePrice',
      'saleStartDate',
      'saleEndDate',
      'noOfItem',
      'bufferQuantity',
      'expireDate',
      'categoryID',
      'imageURI',
      'brandNo',
      'manufactureNo',
      'industrialCode',
      'productionPlace',
      'shippingNo',
      'cancelPeriod',
      'usablePeriod',
      'voucherImageURI',
      'locationType',
      'locationCode',
      'eTicketPassword',
      'requestMessage',
      'itemSpecifics',
      'templateAttribute'
    ]
  },
  shopee: {
    headerRows: [
      'itemTitle',
      'itemDescription',
      'tags',
      'itemAmount',
      'salePrice',
      'saleStartDate',
      'saleEndDate',
      'noOfItem',
      'categoryID',
      'imageURI',
      'shippingServiceDetails',
      'weight(kg)',
      'packageLength(cm)',
      'packageWidth(cm)',
      'packageHeight(cm)',
      'sizeChartImageURI',
      'shippingDuration',
      'itemSpecifics'
    ]
  },
  shopify: {
    headerRows: [
      'itemTitle',
      'itemDescription',
      'compareAtPrice',
      'itemAmount',
      'noOfItem',
      'categoryID',
      'imageURI',
      'vendor',
      'productType',
      'taxable',
      'tags'
    ]
  },
  tokopedia: {
    headerRows: ['itemTitle', 'itemDescription', 'itemAmount', 'noOfItem', 'categoryID', 'imageURI', 'weight(kg)']
  },
  zalora: {
    headerRows: [
      'itemTitle',
      'itemDescription',
      'shortDescription',
      'itemAmount',
      'salePrice',
      'saleStartDate',
      'saleEndDate',
      'noOfItem',
      'categoryID',
      'imageURI',
      'taxClass',
      'brand',
      'model',
      'warrantyType',
      'browseNodes',
      'itemSpecifics',
      'templateAttribute'
    ]
  },
  tiki: {
    headerRows: ['itemDescription', 'itemAmount', 'noOfItem', 'imageUrl', 'mainImageUrl', 'itemSpecifics']
  }
};

export const granularityNotSupportedCharts = ['treemap', 'doughnut2d', 'zoomscatter', 'waterfall2d', 'funnel'];

export const mapChannelStoryLane = {
  lazada: 'https://graas.storylane.io/share/bh6bzcfz66sl',
  shopee: 'https://graas.storylane.io/share/0gfesinme3z2',
  tokopedia: 'https://graas.storylane.io/share/cp7yppefjq2p',
  tiktok: 'https://graas.storylane.io/share/hki7tmyk2zsm',
  flipkart: 'https://graas.storylane.io/share/nxafz7blgfsb',
  amazon: 'https://graas.storylane.io/share/gbbpndgqijrq',
  blibli: 'https://graas.storylane.io/share/9umj23h8sqo3',
  zalora: 'https://graas.storylane.io/share/op1rxyvkvnt0',
  tiki: 'storylink_tiki',
  elevenstreet: 'storylink_elevenStreet',
  etsy: 'https://graas.storylane.io/share/naloplxzooc7',
  bukalapak: 'storylink_bukalapak',
  qoo10: 'https://graas.storylane.io/share/izu6qqgyyzb4',
  ebay: 'storylink_ebay',
  nykaa: 'storylink_nykaa',
  myntra: 'storylink_myntra',
  ajio: 'storylink_ajio',
  shopeeglobal: 'storylink_shopeeGlobal',
  shopify: 'https://graas.storylane.io/share/orgijtmhl8mb',
  magento: 'https://graas.storylane.io/share/re2tkpzavyar',
  woocommerce: 'https://graas.storylane.io/share/r5adfvsrkvb9',
  prestashop: 'https://graas.storylane.io/share/3a9qdiros7xg',
  salesforce: 'https://graas.storylane.io/share/76hzwaz3gnsq',
  googleads: 'https://graas.storylane.io/share/8trkair2fcep',
  facebookads: 'https://graas.storylane.io/share/nrokl2wzgrb3',
  amazonads: 'storylink_amazonAds',
  googlesearchconsole: 'storylink_googleSearchConsole',
  semrush: 'https://graas.storylane.io/share/h4gr4cg4et7n',
  googleanalytics: 'storylink_googleAnalytics',
  shiprocket: 'storylink_shiprocket',
  singpost: 'storylink_singPost',
  jtexpress: 'https://graas.storylane.io/share/snifqlodpe0d',
  janio: 'storylink_janio',
  aramexshipping: 'storylink_aramexShipping',
  ninjavan: 'storylink_ninjaVan',
  citylink: 'storylink_cityLink',
  mailchimp: 'storylink_mailchimp',
  lighthouse: 'storylink_lighthouse',
  mystock: 'storylink_myStock',
  infor: 'storylink_infor',
  ych: 'storylink_ych',
  aramex: 'storylink_aramex',
  satsaco: 'storylink_satsaco',
  siawms: 'storylink_siAWMS',
  customwms: 'storylink_customWMS',
  boxme: 'storylink_boxme',
  flowgistik: 'storylink_flowgistik',
  netsuite: 'https://graas.storylane.io/share/uqtsli8noypg',
  sap: 'https://graas.storylane.io/share/l6hlujd1pazm',
  vend: 'storylink_vend',
  eccang: 'storylink_eccang',
  odoo: 'storylink_odoo',
  offline: 'storylink_offline',
  easyecom: 'storylink_easyEcom',
  zaloraglobal: 'https://graas.storylane.io/share/lntjfklbj7uo',
  flipkart_team_id: 'https://graas.storylane.io/share/isu4xiuu1rdd',
  unicommerce: 'https://graas.storylane.io/share/wlgpisadolcz',
  myntra_team_id: 'https://graas.storylane.io/share/4ycckux5jckm'
};

// hide channels
export const hiddenChannels = ['googleSearchConsole', 'lighthouse', 'semrush', 'mailchimp'];

export const isFeatureDisabled = (features, flag) => {
  for (let i in features) {
    if (features?.[i]?.id === flag && !features?.[i]?.isEnabled) {
      return true;
    }
  }
  return false;
};
export const getConnectedChannels = nickNameList => {
  const uniqueChannels = new Set();
  _map(nickNameList, nickName => {
    if (!nickName?.status || nickName?.status === 'A') {
      const channelId = nickName?.id?.split('-')[0];
      if (channelId) {
        uniqueChannels.add(channelId);
      }
    }
  });
  return Array.from(uniqueChannels);
};

export const getReAuthNeededChannels = (expiryTimeMap, nickNameList) => {
  let totalCountMap = {};
  let expiredChannelCountMap = {};
  const reAuthNeededChannelsList = [];
  //Prepare total count Eg. {'shopee': 2, 'lazada': 4}
  _map(nickNameList, nickName => {
    const channel = nickName?.id?.split('-')[0];
    if (channel !== 'sellInAll') {
      const count = totalCountMap[channel] || 0;
      totalCountMap[channel] = count + 1;
    }
  });
  //Prepare expired channel count Eg. {'shopee': 2, 'lazada': 1}
  for (let [nickNameID, value] of Object.entries(expiryTimeMap)) {
    if (value?.toString().includes('-')) {
      const channel = nickNameID?.split('-')[0];
      const count = expiredChannelCountMap[channel] || 0;
      expiredChannelCountMap[channel] = count + 1;
    }
  }
  for (let [channel, value] of Object.entries(totalCountMap)) {
    if (value === expiredChannelCountMap[channel]) {
      reAuthNeededChannelsList?.push(channel);
    }
  }
  return reAuthNeededChannelsList;
};

// !-- Store classification as per dashboard type
export const ignoreStoresFromAll = [
  'faceBook',
  'facebook',
  'sellInAll',
  'google',
  'semrush',
  'jd',
  'mailchimp',
  'lighthouse',
  'shiprocket',
  'easyEcom',
  'netSuite',
  'sap',
  'odoo',
  'eccang',
  'MyStock',
  'SiAWMS',
  'customWMS',
  'customERP',
  'satsaco',
  'janio',
  'ninjaVan',
  'cityLink',
  'googleAnalytics',
  'google',
  'semrush',
  'vend',
  'infor',
  'ych',
  'boxme',
  'jtExpress',
  'aramex',
  'flowgistik',
  'singPost',
  'Analytics',
  'analytics',
  'googleSearchConsole'
];
export const ignoreForEcommerceDashboard = [
  'facebookAds',
  'googleAds',
  'googleAnalytics',
  'faceBook',
  'facebook',
  'google',
  'googleSearchConsole',
  'amazonAds',
  'tiktokAds'
];
export const marketingChannels = [
  'shopee',
  'shopeeGlobal',
  'lazada',
  'flipkart',
  'facebookAds',
  'googleAds',
  'amazonAds',
  'tokopedia',
  'tiktokAds'
];

export const marketplaceChannels = [
  'shopee',
  'shopeeGlobal',
  'lazada',
  'amazon',
  'flipkart',
  'tokopedia',
  'myntra',
  'nykaa',
  'eBay',
  'qoo10',
  'bukalapak',
  'etsy',
  'elevenStreet',
  'tiktok',
  'blibli',
  'zalora',
  'tiki'
];

export const productMasterChannels = [
  'amazon',
  'bukalapak',
  'blibli',
  'eBay',
  'elevenStreet',
  'etsy',
  'jd',
  'lazada',
  'magento',
  'shopify',
  'shopee',
  'shopeeGlobal',
  'tokopedia',
  'wooCommerce',
  'zalora',
  'tiki',
  'prestaShop',
  'tiktok',
  'myntra',
  'salesforce',
  'qoo10',
  'nykaa'
];

export const rcaIgnoreChannels = ['facebookAds', 'googleAds', 'amazonAds', 'tiktokAds'];
export const productDeepDiveIgnoreChannels = ['facebookAds', 'googleAds', 'amazonAds', 'tiktokAds'];
export const d2cChannels = ['shopify', 'magento', 'wooCommerce', 'prestaShop', 'salesforce'];

export const deepDiveEnabledChannel = ['shopee', 'lazada', 'shopify', 'tokopedia', 'amazon', 'flipkart', 'salesforce'];

// --- Get all stores ID array
export const getAllStores = (nickNameList, code, isGroup, isIncludeInActive = false) => {
  const marketing = marketingChannels || [];
  const eCommerceStores = [];
  const marketingStores = [];
  const financeStores = [];
  const marketplaceStores = [];
  const rcaStores = [];
  const attributionStores = [];
  const insightsStores = [];
  const businessDeepDiveStores = [];
  const mappingStores = [];
  const attributionIgnoreChannels = [];
  const mappingIgnoreStores = [];
  _forEach(nickNameList, name => {
    const split = name?.id?.split('-')?.[0];
    if (!ignoreStoresFromAll.includes(split) && (isIncludeInActive || name?.status !== 'X')) {
      insightsStores?.push(name?.id);
      if (deepDiveEnabledChannel.includes(split)) {
        businessDeepDiveStores?.push(name?.id);
      }
      if (marketing.includes(split)) {
        marketingStores?.push(name?.id);
      }
      if (!ignoreForEcommerceDashboard.includes(split) && (isIncludeInActive || name?.status !== 'X')) {
        eCommerceStores?.push(name?.id);
        financeStores?.push(name?.id);
      }
      if (marketplaceChannels.includes(split)) {
        marketplaceStores?.push(name?.id);
      }
      if (!rcaIgnoreChannels.includes(split)) {
        rcaStores?.push(name?.id);
      }
      if (d2cChannels?.includes(split)) {
        attributionStores?.push(name?.id);
      } else if (!attributionIgnoreChannels?.includes(split)) {
        attributionIgnoreChannels?.push(split);
      }
      if (productMasterChannels.includes(split)) {
        mappingStores?.push(name?.id);
      }
    }
  });
  const customDashboardStores = nickNameList
    ?.filter(item => {
      const nickName = item?.id?.split('-')[0];
      return !ignoreStoresFromAll.includes(nickName) && (isIncludeInActive || item?.status !== 'X');
    })
    .map(item => item.id);
  const obj = {
    'ecommerce-ws': { type: 'stores', value: eCommerceStores },
    'combined-ws': { type: 'stores', value: _uniq([...eCommerceStores, ...marketingStores]) },
    'marketing-ws': { type: 'stores', value: marketingStores },
    'finance-ws': { type: 'stores', value: financeStores },
    marketplace: { type: 'stores', value: marketplaceStores },
    attribution: { type: 'stores', value: attributionStores, disabledValue: attributionIgnoreChannels },
    rca: { type: 'stores', value: rcaStores, disabledValue: rcaIgnoreChannels },
    insights: { type: 'stores', value: insightsStores },
    deepDive: { type: 'stores', value: businessDeepDiveStores },
    custom_dashboard: { type: 'stores', value: customDashboardStores },
    brandMapping: { type: 'stores', value: mappingStores, disabledValue: _uniq(mappingIgnoreStores) }
  };

  if (code?.includes('custom_template') || code?.includes('custom_dashboard')) {
    return obj['custom_dashboard'];
  }
  if (code && !_isEmpty(code)) return obj[code];
  if (isGroup && isGroup === 'group') return obj['custom_dashboard'];
  return obj;
};

export const getInitialFilteredChannels = (nickNameList, code, isIncludeInActive) => {
  const marketing = marketingChannels || [];
  let filteredList = [];
  if (code && !_isEmpty(code)) {
    filteredList = _filter(nickNameList, name => {
      const split = name?.id?.split('-')?.[0];
      if (!ignoreStoresFromAll.includes(split) && (isIncludeInActive || name?.status !== 'X')) {
        if (code === 'marketing-ws') {
          if (marketing.includes(split)) {
            return name;
          }
        }
        if (code === 'ecommerce-ws' || code === 'finance-ws' || code === 'combined-ws') {
          if (!ignoreForEcommerceDashboard.includes(split)) {
            return name;
          }
        }
        if (code === 'productMaster' || code === 'brandMapping') {
          if (productMasterChannels.includes(split)) {
            return name;
          }
        }
        if (code === 'custom_dashboard' || code === 'attribution' || code === 'insights' || code === 'predict') {
          return name;
        }
      }
    });
  } else {
    filteredList = _filter(nickNameList, name => {
      const split = name?.id?.split('-')?.[0];
      if (!ignoreStoresFromAll.includes(split) && (isIncludeInActive || name?.status !== 'X')) {
        return name;
      }
    });
  }
  return filteredList || [];
};

export const getMaxConfigOfY = visualizationSet => {
  return _maxBy(visualizationSet, 'config.y')?.config?.y + 2 || 0;
};

export const getCountryName = countryCode => {
  for (let index in countryDetails) {
    if (countryDetails[index]?.countryCode === countryCode) {
      return countryDetails[index]?.countryName;
    }
  }
};

export const globalFilterRoute = [
  '/analyze/rca',
  '/analyze/workspace',
  '/analyze/marketing-deep-dive',
  '/analyze/insights',
  '/analyze/attribution-model',
  '/finance-orderIncome',
  '/predict',
  '/analyze/product-deepdive',
  '/connect/mapping',
  '/executor/mapping',
  routesMapping['home']
];

export const getEnabledFlag = (features, flag) => {
  for (let i in features) {
    if (features?.[i]?.id === flag && features?.[i]?.isEnabled) {
      return true;
    }
  }
  return false;
};

export const getIconName = key => {
  switch (key) {
    case 'store':
      return 'storefront';
    case 'product':
      return 'barcode';
    case 'store_group':
      return 'group_work';
    case 'brand':
      return 'workspace_premium';
    default:
      return 'storefront';
  }
};

export const getGranularity = (start, end) => {
  let startDate = new Date(start);
  let endDate = new Date(end);
  let time_difference = endDate.getTime() - startDate.getTime();
  let days_difference = time_difference / (1000 * 60 * 60 * 24);
  if (days_difference < 10) {
    return 'day';
  } else if (days_difference < 45) {
    return 'week';
  } else if (days_difference < 366) {
    return 'month';
  } else {
    return 'year';
  }
};

//Date Ranges
export const ranges = {
  Today: [moment(), moment()],
  Yesterday: [moment().subtract(1, 'd'), moment().subtract(1, 'd')],
  'This Week': [moment().startOf('week'), moment()],
  'Last Week': [moment().startOf('week').subtract(1, 'week'), moment().endOf('week').subtract(1, 'week')],
  'Last 7 days': [moment().subtract(6, 'd'), moment()],
  'Last 14 days': [moment().subtract(13, 'd'), moment()],
  'Last 28 days': [moment().subtract(27, 'd'), moment()],
  'This Month': [moment().startOf('month'), moment()],
  'Last month': [moment().startOf('month').subtract(1, 'months'), moment().startOf('month').subtract(1, 'days')],
  'This Quarter': [moment().startOf('quarter'), moment()],
  'Last Quarter': [
    moment().startOf('quarter').subtract(1, 'quarters'),
    moment().endOf('quarter').subtract(1, 'quarters')
  ],
  'This Year': [moment().startOf('year'), moment()],
  'Last Year': [moment().startOf('year').subtract(1, 'years'), moment().endOf('year').subtract(1, 'years')]
};

// --- Utility to convert date as per provided format
export const onFormatDate = (date, format, dateType) => {
  if (_isEmpty(date)) return null;
  if (_isEmpty(dateType)) {
    return moment(date).format(format || 'DD MMM YYYY') || date;
  }
  if (dateType === 'start') {
    return (
      moment(date)
        .startOf('day')
        .format(format || 'DD MMM YYYY') || date
    );
  }
  return (
    moment(date)
      .endOf('day')
      .format(format || 'DD MMM YYYY') || date
  );
};

// --- get start_date end_date time stamp object
export const getTimeStamps = selectedDateRange => {
  if (_isEmpty(selectedDateRange)) return null;

  return {
    start_date: _isArray(selectedDateRange)
      ? onFormatDate(selectedDateRange?.[0], 'X', 'start')
      : onFormatDate(dateRangeMapping[selectedDateRange]?.value?.[0], 'X', 'start') || '',
    end_date: _isArray(selectedDateRange)
      ? onFormatDate(selectedDateRange?.[1] ? selectedDateRange?.[1] : selectedDateRange?.[0], 'X', 'end')
      : onFormatDate(dateRangeMapping[selectedDateRange]?.value?.[1], 'X', 'end') || ''
  };
};

// --- render count / currency in table
export const renderAmount = config => {
  const { amount, isCurrency, currencySymbol, isToFixed, isNoDivideByTen } = config;
  let value = amount;

  // --- IF NOT CURRENCY
  if (!isCurrency) {
    // --- check isNan
    if (_isNaN(amount) || _isUndefined(amount) || amount === 'NULL' || amount === 'null' || _isNull(amount)) {
      value = 'NA';
    } else if (_isString(amount) && amount !== 'NULL') {
      // --- check value is string convert it to number
      value = +amount;
    } else {
      if (isToFixed) {
        value = +amount.toFixed(2);
      } else {
        value = amount?.toLocaleString('en-US');
      }
    }
  } else {
    if (_isNaN(amount) || _isUndefined(amount) || amount === 'NULL' || _isNull(amount)) {
      value = 'NA';
    } else if (amount === 0) {
      value = amount;
    } else {
      let amt = +(amount / 100).toFixed(2);
      if (isNoDivideByTen) {
        amt = amount;
      }

      if (_isEmpty(currencySymbol)) {
        value = `${amt?.toLocaleString('en-US')}`;
      } else {
        value = `${amt?.toLocaleString('en-US')} ${currencySymbol}`;
      }
    }
  }
  return value;
};

//check managed account in nickName level
export const checkIsManagedAccount = (accountDetails, connectedList) => {
  let uniqueChannelList = [];
  for (let index in connectedList) {
    let channelName = connectedList[index].split('-')[0];
    if (!uniqueChannelList.includes(channelName)) {
      uniqueChannelList?.push(channelName);
    }
  }
  for (let channel of uniqueChannelList) {
    if (accountDetails[channel]?.some(channelData => channelData.isManaged === true)) {
      return true;
    }
  }
  return false;
};

export const getManagedNickNameList = (accountDetails, sitename) => {
  return accountDetails?.[sitename]
    ?.filter(item => (item?.isManaged && item?.isTransactionFee) || (!item?.isManaged && item?.isTransactionFee))
    .map(item => item?.nickName?.id);
};

export const isBillPlanIDEnabled = (billPlanDetails, requestedBillPlanID) =>
  billPlanDetails.filter(billPlanDetail => billPlanDetail?.moduleID === requestedBillPlanID).length > 0;

export const clearCookie = () => {
  const cookiesToDelete = [
    'accessToken',
    'refreshToken',
    'locale',
    'chromeExtensionRemindLater',
    'accountNumber',
    'userId',
    'merchantID',
    'username',
    'isRCAZeroIndexLoaded',
    'countryCode'
  ];

  const dynamicCookieKeys = ['IsExpiryPopUpShown', 'isChannelAuthPopupLoaded', 'userLandedInDefaultPage'];
  const cookieDomain = process.env.NODE_ENV === 'development' ? 'localhost' : process.env.REACT_APP_COOKIE_PATH;

  _map(cookiesToDelete, cookieName => {
    document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=${cookieDomain};path=/`;
  });

  var cookieNames = document.cookie.split(/=[^;]*(?:;\s*|$)/);
  _map(cookieNames, cookieName => {
    _map(dynamicCookieKeys, key => {
      if (cookieName.includes(key)) {
        document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=${cookieDomain};path=/`;
      }
    });
  });

  localStorage.removeItem('user_metadata');
  localStorage.clear();
  sessionStorage.clear();
};

export const hourWiseSupportedChart = ['MultiAxisLine', 'msspline', 'msstackedcolumn2d'];

export const generateUniqueName = (name, prefix) => {
  const uniqueName = `${prefix ?? ''}${name}`;
  return uniqueName?.replaceAll(' ', '-')?.replaceAll('(', '')?.replaceAll(')', '');
};

export const financeSupportedChannels = [
  'zalora',
  'shopify',
  'qoo10',
  'blibli',
  'tiktok',
  'shopeeGlobal',
  'lazada',
  'amazon',
  'tokopedia',
  'shopee'
];

export const financeNonManagedSupportedChannels = ['lazada', 'shopee', 'shopeeGlobal', 'zalora', 'tokopedia', 'tiktok'];

export const getOrderIncomeSelectedStores = (isAdminUser, accountDetails, connectedList, nickNameList, key) => {
  const isMangedSeller = checkIsManagedAccount(accountDetails, connectedList);
  let disabledChannels = [];
  let availableChannels = [];
  _forEach(nickNameList, nickName => {
    if ((isAdminUser || isMangedSeller) && financeSupportedChannels?.includes(nickName?.id?.split('-')[0]))
      availableChannels?.push(nickName?.id);
    else if (!isMangedSeller && financeNonManagedSupportedChannels?.includes(nickName?.id?.split('-')[0]))
      availableChannels?.push(nickName?.id);
    else disabledChannels?.push(nickName?.id?.split('-')[0]);
  });
  return key === 'disabledChannel' ? disabledChannels : { type: 'stores', value: availableChannels };
};

export const switchToDemo = async (accountDetails, hasWriteAccess) => {
  if (hasWriteAccess) {
    mouseflowTrack(
      {
        username: accountDetails?.userDetails?.name || '',
        email: accountDetails?.userDetails?.SELLinALLId || '',
        storeCode: accountDetails?.merchantID || '',
        isDemoAccount: !hasWriteAccess
      },
      'ACCESS_DEMO_ACCOUNT_BUTTON_CLICKED'
    );
  }
  let accessToken = Cookies.get('accessToken');
  let refershToken = Cookies.get('refreshToken');
  if (Cookies.get('oldAccessToken') && Cookies.get('oldRefershToken')) {
    let oldAccessToken = Cookies.get('oldAccessToken');
    let oldRefershToken = Cookies.get('oldRefershToken');
    setAccessTokenCookies(
      oldAccessToken,
      oldRefershToken,
      accessToken,
      refershToken,
      accountDetails?.timeCreated,
      accountDetails?.merchantID
    );
    window.location.replace('/analyze');
  } else {
    const visitorId = await fetchFingerprint();
    const postPayload = {
      emailId:
        accountDetails?.countryCode === 'IN'
          ? process.env.REACT_APP_DEMO_IN_ACCOUNT_EMAIL
          : process.env.REACT_APP_DEMO_ACCOUNT_EMAIL,
      isDemoAccount: true,
      visitorId: visitorId || ''
    };
    const response = await postDataFromApiAction(`${apiServices['auth']}services/authToken/v1`, postPayload);
    if (response?.accessToken && response?.refreshToken) {
      setAccessTokenCookies(
        response?.accessToken,
        response?.refreshToken,
        accessToken,
        refershToken,
        accountDetails?.timeCreated,
        accountDetails?.merchantID
      );
      window.location.replace('/analyze');
    }
  }
};

export const checkDemoAccess = (accountDetails, hasWriteAccess) => {
  if (!hasWriteAccess) return true;
  if (accountDetails?.timeCreated) {
    const epochTimeInMilliseconds = accountDetails?.timeCreated * 1000;
    const currentTime = Date.now();
    const timeDifference = currentTime - epochTimeInMilliseconds;
    const daysDiff = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    return daysDiff < 7;
  } else {
    return false;
  }
};

export const isEpochFromTodayOnward = epoch => {
  const date = moment(epoch < 1e12 ? epoch * 1000 : epoch);
  return date.isSameOrAfter(moment(), 'day');
};

export const setAccessTokenCookies = (
  oldAccessToken,
  oldRefershToken,
  accessToken,
  refershToken,
  timeCreated,
  merchantID
) => {
  setCookies('accessToken', oldAccessToken, 1, 'day');
  setCookies('refreshToken', oldRefershToken, 1, 'day');
  setCookies('oldAccessToken', accessToken, 1, 'day');
  setCookies('oldRefershToken', refershToken, 1, 'day');
  setCookies('timeCreated', timeCreated, 1, 'day');
  setCookies('storeCode', merchantID, 1, 'day');
};

export const southEastAsiaCountries = ['ID', 'MY', 'PH', 'TH', 'VN', 'SG'];

export const tooltipNAMapper = {
  'N.A': 'GRAAS_NOT_APPLICABLE_GRAAS',
  'N/A': 'GRAAS_NA_SHORTFORM_GRAAS'
};

export const updateUserDefinedDisplayName = (definedDisplayName = {}, categoryMapping = {}, dimensionLit = []) => {
  _forEach(dimensionLit, dimension => {
    let custome_category_value = _find(categoryMapping, Category => Category?.id === dimension)?.value;
    if (custome_category_value) {
      definedDisplayName[dimension] = custome_category_value;
    }
  });
  return definedDisplayName;
};

// *** Get compare date range
export const getCompareDateRange = dateRange => {
  let dateRangeDuration = 'custom';
  const start = moment(dateRange[0]);
  const end = moment(dateRange[1]);
  const duration = end.diff(start, 'days');
  const daysInSelectedMonth = start?.daysInMonth();
  const daysInSelectedYear = moment(`${start.year()}-12-31`).dayOfYear();
  if (daysInSelectedMonth === duration + 1 && end.clone().startOf('month').isSame(start.clone().startOf('month'))) {
    dateRangeDuration = 'month';
  } else if (daysInSelectedYear === duration + 1 && end.clone().startOf('year').isSame(start.clone().startOf('year'))) {
    dateRangeDuration = 'year';
  }
  let compareRange;
  if (dateRangeDuration === 'month' || dateRangeDuration === 'year') {
    compareRange = [start.clone().subtract(1, dateRangeDuration), moment(start).subtract(1, 'd')];
  } else {
    let diff = end.diff(start);
    compareRange = [moment(start).subtract(diff).subtract(1, 'd'), moment(end).subtract(diff).subtract(1, 'd')];
  }
  return compareRange;
};

//! Custom Category Name (changed by user)
export const getCustomCategoryName = (id, customCategory) => {
  const found = _find(
    customCategory,
    item =>
      item?.id?.split('_')?.join('')?.toLowerCase() === id?.toLowerCase() ||
      item?.id?.toLowerCase() === id?.toLowerCase()
  );

  return found?.value;
};

export const retryApiattempts = async (attenpts, apiUrl, payload) => {
  if (attenpts < 0) {
    return {
      isError: true
    };
  }
  const response = await postDataFromApiAction(apiUrl, payload);
  if (response?.is_default_response) {
    await new Promise(resolve => setTimeout(resolve, 2000));
    return retryApiattempts(attenpts - 1, apiUrl, payload);
  }
  return response;
};

export const getInitialColumnsInQuery = (query, metricsDisplayMapping) => {
  let initColumn = [];
  _forEach(getColumnOrder(query), item => {
    initColumn?.push({ title: metricsDisplayMapping?.[item], dataIndex: item, key: item });
  });
  return initColumn;
};

export const getColumnOrder = query => {
  const dimensionsList = _uniq(_flatten(_map(query, item => item.dimensions)));
  const measuresList = _uniq(_flatten(_map(query, item => item.measures)));
  return [...dimensionsList, ...measuresList] || [];
};

export const getDefaultEmptyMessageForInsights = (connectedList, merchantData, defaultmessage) => {
  let getDefaultEmptyMessage = t('GRAAS_NO_INSIGHTS_AVAILABLE_GRAAS') + ' ' + t('GRAAS_FOR_SELECTED_DATE_RANGE_GRAAS');
  if (!_isEmpty(defaultmessage)) {
    getDefaultEmptyMessage = defaultmessage;
  }
  let uniqueChannelList = [];
  for (let index in connectedList) {
    let channelName = connectedList[index].split('-')[0];
    if (!uniqueChannelList.includes(channelName)) {
      uniqueChannelList?.push(channelName);
    }
  }
  let isLast24HrsExceeded = false;
  for (let uniqueChannelIndex in uniqueChannelList) {
    let channelList = merchantData[uniqueChannelList[uniqueChannelIndex]];
    for (let channelIndex in channelList) {
      let channelObject = channelList[channelIndex];
      if (channelObject?.timeLinked) {
        let currentTime = moment().unix();
        let bufferTime = channelObject?.timeLinked + 60 * 60 * 24;
        if (currentTime > bufferTime) {
          isLast24HrsExceeded = true;
          break;
        }
      }
    }
    if (isLast24HrsExceeded) {
      break;
    }
  }
  if (!isLast24HrsExceeded) {
    getDefaultEmptyMessage = t('GRAAS_IT_MAY_TAKE_UP_TO_SOME_HOURS_TO_DISPLAY_INSIGHTS_GRAAS');
  }
  return getDefaultEmptyMessage;
};
export const getFilteredData = data => {
  let filterData = [];
  _forEach(data, dataobj => {
    if (dataobj?.applications_in_use.includes('Chart Builder')) {
      filterData?.push(dataobj);
    }
  });
  return filterData;
};

export const chromeUICondition = (
  metricsList,
  chromeBasedMetrics,
  isChromeExtensionInstalled,
  installedAfterRedirection
) => {
  let hasChromeMetric = false;
  if (!_isEmpty(metricsList)) {
    hasChromeMetric = metricsList?.some(val => chromeBasedMetrics?.includes(val));
  }
  if (!hasChromeMetric) return false;
  if (isChromeExtensionInstalled || installedAfterRedirection) return false;
  return true;
};

export const getTimeZoneByNickNameID = (nickNameID, nickNameList) => {
  const nickName = nickNameList.find(nick => nick.id === nickNameID);
  if (!nickName) return Intl.DateTimeFormat().resolvedOptions().timeZone;
  const currencyCode = nickName?.currencyCode;
  const countryDetail = countryDetails.find(detail => detail.currencyCode === currencyCode);
  return countryDetail?.timeZone;
};

export const computeCompareDateRange = date => {
  const diff = moment(date[1]).diff(moment(date[0]), 'days');
  return [moment(date[0]).subtract(diff + 1, 'd'), moment(date[1]).subtract(diff + 1, 'd')];
};

export const metricStatusVal = {
  all: 'All',
  incomplete: 'Incomplete',
  complete: 'Completed',
  'in progress': 'In Progress'
};

export const getDeviceInformation = () => {
  const module = {
    header: navigator.userAgent,
    dataos: [
      { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
      { name: 'Windows', value: 'Win', version: 'NT' },
      { name: 'iPhone', value: 'iPhone', version: 'OS' },
      { name: 'iPad', value: 'iPad', version: 'OS' },
      { name: 'Kindle', value: 'Silk', version: 'Silk' },
      { name: 'Android', value: 'Android', version: 'Android' },
      { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
      { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
      { name: 'Macintosh', value: 'Mac', version: 'OS X' },
      { name: 'Linux', value: 'Linux', version: 'rv' },
      { name: 'Palm', value: 'Palm', version: 'PalmOS' }
    ],
    databrowser: [
      { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
      { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
      { name: 'Safari', value: 'Safari', version: 'Version' },
      { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
      { name: 'Opera', value: 'Opera', version: 'Opera' },
      { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
      { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
    ],

    init() {
      const agent = this.header;
      const os = this.matchItem(agent, this.dataos);
      const browser = this.matchItem(agent, this.databrowser);

      return {
        os,
        browser,
        agent,
        deviceType: this.detectDeviceType(agent)
      };
    },

    matchItem(string, data) {
      for (let i = 0; i < data.length; i++) {
        const regex = new RegExp(data[i].value, 'i');
        if (regex.test(string)) {
          const regexv = new RegExp(`${data[i].version}[- /:;]([\\d._]+)`, 'i');
          const matches = string.match(regexv);
          const version = matches ? matches[1].split(/[._]+/).join('.') : '0';

          return {
            name: data[i].name,
            version: parseFloat(version)
          };
        }
      }
      return { name: 'unknown', version: 0 };
    },

    detectDeviceType(userAgent) {
      const isMobile =
        /android|iphone|ipod|blackberry|bb|windows phone|webos|opera mini|opera mobi|iemobile|mobile/i.test(userAgent);
      const isTablet = /ipad|tablet|kindle|playbook/i.test(userAgent);

      if (isTablet) {
        return 'Tablet';
      } else if (isMobile) {
        return 'Mobile';
      }
      return 'Desktop';
    }
  };

  const result = module.init();

  return {
    os: result.os,
    browser: result.browser,
    agent: result.agent,
    deviceType: result.deviceType
  };
};

export const isProductionEnvironment = () => {
  return process.env.NODE_ENV === 'production';
};

export const getIpDetails = async () => {
  const isDemoHost = getIsDemoHost();
  const apiUrl = isDemoHost
    ? process.env.REACT_APP_DEMO_DETECT_COUNTRY_API_HOST
    : process.env.REACT_APP_DETECT_COUNTRY_API_HOST;
  let result = {};
  if (apiUrl) {
    try {
      const response = await fetch(apiUrl);
      if (response.ok) {
        result = await response.json();
      }
    } catch (error) {
      console.error('Error fetching IP details:', error);
    }
  }
  return result;
};

export const generateGoogleCSV = async (
  sheetName,
  CSV_payload,
  setIsGoogleSheetLoading,
  setshowGoogleConnectModal,
  googleChannelDetails,
  navigate,
  tableRows
) => {
  if (_isEmpty(googleChannelDetails)) {
    setshowGoogleConnectModal(true);
  } else if (_isEmpty(tableRows)) {
    message.error(t('GRAAS_NO_DATA_AVAILABLE_TO_CREATE_SHEET_GRAAS'));
  } else {
    setIsGoogleSheetLoading(true);
    CSV_payload.sheetChartName = `Graas Chart - ${sheetName}`;
    const url = `${apiServices['batch']}/services/documents`;
    const response = await postDataFromApiAction(url, { data: CSV_payload });
    if (response?.status === 'Success') {
      navigate('/analyze/reports');
    } else {
      message.error(t('GRAAS_NO_DATA_AVAILABLE_TO_CREATE_SHEET_GRAAS'));
    }
    setIsGoogleSheetLoading(false);
  }
};

export const showNickNameValue = (siteNicknameIds, nickNameList, maxVisibleCount) => {
  const maxVisible = maxVisibleCount || 5;
  const visibleNicknames = _slice(siteNicknameIds, 0, maxVisible);
  const hiddenNicknames = _slice(siteNicknameIds, maxVisible);

  const renderNickName = nickNameID => {
    const channelName =
      `${capitalizeFirstLetter(nickNameID.split('-')[0]) + '-' + getNickNameValue(nickNameList, nickNameID, nickNameID)
      }` ||
      nickNameID ||
      '';
    return (
      <span className='Graas-tag rounded with-image'>
        <img src={channelToLogo?.[nickNameID.split('-')[0]]?.small || channelToLogo?.noLogo?.small} alt='logo' />
        <TooltipWrapper
          title={<span className='Graas-heading size-6 color-white mgb-0'>{channelName}</span>}
          overlayClassName='Graas_toolTip'
          isShowTooltip={channelName?.length > 18}
        >
          {channelName}
        </TooltipWrapper>
      </span>
    );
  };

  return (
    <div className='Graas-tagList'>
      <ul>
        {visibleNicknames.map((nickNameID, index) => (
          <li key={index}>{renderNickName(nickNameID)}</li>
        ))}

        {hiddenNicknames.length > 0 && (
          <li>
            <TooltipWrapper
              title={
                <div className='Graas-tagList'>
                  <ul>
                    {hiddenNicknames.map((nickNameID, index) => (
                      <li key={index}>{renderNickName(nickNameID)}</li>
                    ))}
                  </ul>
                </div>
              }
              overlayClassName='Graas_toolTip withLightColor'
              isShowTooltip={true}
            >
              <span className='Graas-tag rounded'>+{hiddenNicknames?.length} more</span>
            </TooltipWrapper>
          </li>
        )}
      </ul>
    </div>
  );
};

export const inverseDeviationMetrics = ['CPC', 'CAC'];

export const SEA_COUNTRIES = ['SG', 'MY', 'PH', 'TH', 'VN', 'ID', 'BN', 'KH', 'TL', 'LA', 'MM'];

export async function fetchFingerprint() {
  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
  } catch (error) {
    console.error('Failed to get fingerprint', error);
  }
}

/*
 * @param {Object} newParams - The new query parameters to be added to the URL.
 * @example:
 * updateQueryParams({ connectJournal: 'drawer' });
 */

export const updateQueryParams = (newParams = {}) => {
  const currentParams = queryString.parse(window.location.search);
  for (const key in newParams) {
    if (_isNull(newParams[key]) || _isUndefined(newParams[key]) || _isEmpty(newParams[key])) {
      delete currentParams[key];
    } else {
      currentParams[key] = newParams[key];
    }
  }
  const newSearch = queryString.stringify(currentParams);
  const newUrl = `${window.location.pathname}${newSearch ? '?' : ''}${newSearch}`;
  window.history.pushState({}, '', newUrl);
};
